import {Base} from "@/api/Base"

export class AttendanceLogsAdd extends Base {
    path = "attendanceLogs/add"
}